import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { of } from 'rxjs';
import { MetaTagsService } from '../../../services/meta-tags/meta-tags.service';

export const metaResolver: ResolveFn<any | null> = (route, state) => {
  const metaService = inject(MetaTagsService);

  const url = state.url;

  const path = route.params?.['name'] || route.params?.['path'] || '';
  const subCategory = route.params?.['model'] || '';
  const model = route.params?.['sku'] || '';
  const querySearch = route.params?.['querySearch'] || '';
  const hashBudget = route.params?.['hashBudget'] || '';
  const email = route.params?.['email'] || '';

  let page = MetaTagsService.PAGE_HOME;

  if (url === '/') page = MetaTagsService.PAGE_HOME;
  else if (url.includes('quem-somos')) page = MetaTagsService.PAGE_ABOUT;
  else if (url.includes('nova-senha')) page = MetaTagsService.PAGE_FORGOT;
  else if (url.includes('novo-cadastro')) page = MetaTagsService.PAGE_REGISTER;
  else if (url.includes('fale-conosco')) page = MetaTagsService.PAGE_CONTACT;
  else if (url.includes('sac')) page = MetaTagsService.PAGE_SAC;
  else if (url.includes('seja-um-revendedor'))
    page = MetaTagsService.PAGE_DEALER;
  else if (url.includes('catalogos')) page = MetaTagsService.PAGE_CATALOG;
  else if (url.includes('politicas-trocas-cancelamentos'))
    page = MetaTagsService.PAGE_POLICIES;
  else if (url.includes('termos-condicoes-uso'))
    page = MetaTagsService.PAGE_TERMS;
  else if (url.includes('faq')) page = MetaTagsService.PAGE_FAQ;
  else if (url.includes('aviso-de-privacidade'))
    page = MetaTagsService.PAGE_PRIVACY;
  else if (url.includes('login')) page = MetaTagsService.PAGE_LOGIN;
  else if (url.includes('carrinho')) page = MetaTagsService.PAGE_CART;
  else if (url.includes('orcamento')) page = MetaTagsService.PAGE_BUDGET;
  else if (url.includes('black-friday')) page = MetaTagsService.PAGE_CATEGORIES;
  else if (url.includes('pagamento')) page = MetaTagsService.PAGE_PAYMENT;
  else if (url.includes('meus-dados'))
    page = MetaTagsService.PAGE_CUSTOMER_AREA_DATA;
  else if (url.includes('meu-endereco'))
    page = MetaTagsService.PAGE_CUSTOMER_AREA_ADDRESS;
  else if (url.includes('meus-pedidos'))
    page = MetaTagsService.PAGE_CUSTOMER_AREA_ORDERS;
  else if (url.includes('area-do-cliente'))
    page = MetaTagsService.PAGE_CUSTOMER_AREA;
  else if (url.includes('confirmacao'))
    page = MetaTagsService.PAGE_ORDER_PLACED;
  else if (url.includes('pagina-nao-encontrada'))
    page = MetaTagsService.PAGE_NOT_FOUND;
  else if (url.includes('/produtos/') && querySearch)
    page = MetaTagsService.PAGE_PRODUCTS;
  else if (url.includes('/produtos/')) page = MetaTagsService.PAGE_PRODUCTS;
  else if (
    url.includes('/ambientes') ||
    url.includes('/rolo') ||
    url.includes('/romana') ||
    url.includes('/colecoes') ||
    url.includes('/double-vision') ||
    url.includes('/horizontal') ||
    url.includes('/pronta-entrega')
  ) {
    page = MetaTagsService.PAGE_CATEGORIES;
  }

  metaService.configTagPages(
    page,
    path || url,
    subCategory,
    model,
    querySearch || hashBudget || email || null
  );
  return of(true);
};
